export default {"src":"/_next/static/image/public/images/report-ready.9c10b72ca7fe723139a126e359f36a12.svg","height":17,"width":24};